// src/context/ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

// Create Theme Context
const ThemeContext = createContext();

// Custom hook to use theme
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

// Theme Provider Component
export const ThemeProvider = ({ children }) => {
  // ⭐ DEFAULT = light (white), but keep saved preference if exists
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme || "light";
  });

  // Toggle between themes
  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
  };

  // Save theme + apply to document
  useEffect(() => {
    localStorage.setItem("theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
    document.body.className = `theme-${theme}`;
  }, [theme]);

  // Theme configuration object
  const themeConfig = {
    dark: { 
      header: "/css/Header.css",
      hero: "/css/Hero.css",
      about: "/css/About.css",
      cards: "/css/cards.css",
      contact: "/css/Contact.css",
      course: "/css/Course.css",
      popup: "/css/popup.css",
      footer: "/css/Footer.css",
      courseOverview:"/css/CourseOverview.css",
      workshop:"/css/workshop.css",
      PaymentPage: "/css/PaymentPage-dark.css",
      driveregister: "/css/driveregister.css",

    },

    light: {
      header: "/css/Header-light.css",
      hero: "/css/Hero-light.css",
      about: "/css/About.css",
      cards: "/css/cards-light.css",
      contact: "/css/Contact.css",
      course: "/css/Course-light.css",
      popup: "/css/popup-light.css",
      footer: "/css/Footer-light.css",
      courseOverview:"/css/CourseOverview-light.css",
      workshop:"/css/workshop.css",
      PaymentPage: "/css/PaymentPage.css",
      driveregister: "/css/driveregister.css",

    },
  };

  const value = {
    theme,
    toggleTheme,
    themeConfig,
    isDark: theme === "dark",
    isLight: theme === "light",
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;